<template>
  <div v-if="pageCount > 1" class="pagination">
    <div class="pagination__control">
      <a
        v-if="!type && data.page > 1"
        :href="data.linkUrl + 'P=' + (data.page - 1)"
        class="pagination__btn pagination__btn--prev"
      />
      <a
        v-if="type && data.pageTotal > 1"
        :href="data.linkUrl + 'P=' + (data.page - 1)"
        :class="{ disabled: data.page === 1 }"
        class="pagination__btn pagination__btn--prev"
      />
      <div v-if="data.pageTotal <= data.maxCont + 1" class="d-inline-block">
        <PaginatorLessThanMaxCont :data="data" />
      </div>
      <div v-else class="d-inline-block">
        <PaginatorFirstMaxCont v-if="data.page < data.maxCont" :data="data" />
        <PaginatorLastMax v-else-if="data.pageTotal - data.page < data.maxCont" :data="data" />
        <PaginatorNormal v-else :data="data" />
      </div>
      <a
        v-if="!type && data.page < data.pageTotal"
        :href="data.linkUrl + 'P=' + (data.page + 1)"
        class="pagination__btn pagination__btn--next"
      />
      <a
        v-if="type && data.pageTotal > 1"
        :href="data.linkUrl + 'P=' + (data.page + 1)"
        :class="{ disabled: data.page === data.pageTotal }"
        class="pagination__btn pagination__btn--next"
      />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import PaginatorLessThanMaxCont from '@global/components/common/pagination/parts/PaginatorLessThanMaxCont.vue';
import PaginatorFirstMaxCont from '@global/components/common/pagination/parts/PaginatorFirstMaxCont.vue';
import PaginatorLastMax from '@global/components/common/pagination/parts/PaginatorLastMax.vue';
import PaginatorNormal from '@global/components/common/pagination/parts/PaginatorNormal.vue';

/**
 * @typedef {Object} Props
 * @property {number} totalPage API 回傳的值
 * @param {boolean} type 強制顯示箭頭 theButter
 */

const props = defineProps({
  totalPage: {
    type: Number,
    default: 0,
    required: false,
  },
  type: {
    type: Boolean,
    default: false,
  },
});

const data = ref({});
const nowPage = ref(1);

// 列表頁等套版是靠後端控window.PageCount，其他有打API例如趨勢文章直接取得
const pageCount = ref(props.totalPage || window.PageCount);

function init() {
  const nowLocation = window.location.toString();
  let args = 0;
  let argsString = '';
  const searchLocation = window.location.search;

  // 先把篩選參數裝起來並刪除page
  if (nowLocation.indexOf('?') !== -1) {
    args = nowLocation.split('?')[1].split('&');
    let i = 0;
    while (i < args.length) {
      if (args[i].indexOf('P=') !== -1) {
        args.splice(i, 1);
      } else {
        i += 1;
      }
    }
    // 再把篩選參數組回去
    if (args.length !== 0) {
      argsString = `${args.join('&')}&`;
    }
  }

  if (searchLocation.length !== 0) {
    args = searchLocation.split('?')[1].split('&');
    for (let i = 0; i < args.length; i++) {
      if (args[i].indexOf('P=') !== -1) {
        nowPage.value = parseInt(args[i].replace('P=', ''));
      }
    }
  } else {
    nowPage.value = 1;
  }
  const linkUrl = `${window.location.pathname}?${argsString}`;
  data.value = {
    maxCont: 5, // 設定分頁選擇器最大連續個數
    page: nowPage.value,
    pageTotal: pageCount.value,
    linkUrl,
  };
}
init();
</script>
